// assets/wishlist.js

const WISHLIST_LOCAL_STORAGE_KEY = 'my_shop_wishlist_products';

function adjustWishlistDrawerPosition() {
  const header = document.querySelector('.header');
  const wishlistDrawer = document.getElementById('wishlistDrawer');
  if (!header || !wishlistDrawer) return;
  
  const headerRect = header.getBoundingClientRect();
  // Sätt drawerns övre kant precis vid headerns botten
  wishlistDrawer.style.top = headerRect.bottom + 'px';
}

document.addEventListener('DOMContentLoaded', adjustWishlistDrawerPosition);
window.addEventListener('resize', adjustWishlistDrawerPosition);

document.addEventListener('DOMContentLoaded', () => {
  const storedFavorites = loadFavorites();
  markFavoriteHearts(storedFavorites);
  initHeartButtons();
  updateWishlistDrawer();
  initHeaderWishlistIcon();
  updateWishlistCountBubble();

  // Observera event i relaterade produkter (om det behövs)
  const relatedContainer = document.querySelector('.related-products');
  if (relatedContainer) {
    const observer = new MutationObserver(() => {
      markFavoriteHearts(loadFavorites());
    });
    observer.observe(relatedContainer, { childList: true, subtree: true });
  }
});

function loadFavorites() {
  try {
    const data = localStorage.getItem(WISHLIST_LOCAL_STORAGE_KEY);
    return data ? JSON.parse(data) : [];
  } catch (e) {
    console.warn('Kunde inte läsa favoriter från localStorage', e);
    return [];
  }
}

function saveFavorites(favorites) {
  localStorage.setItem(WISHLIST_LOCAL_STORAGE_KEY, JSON.stringify(favorites));
}

function markFavoriteHearts(favorites) {
  const heartButtons = document.querySelectorAll('.wishlist-heart-button');
  heartButtons.forEach((btn) => {
    const productId = btn.getAttribute('data-product-id');
    btn.removeAttribute('data-favorite');
    if (favorites.includes(productId)) {
      btn.setAttribute('data-favorite', 'true');
    }
  });
}

function positionWishlistDrawer() {
  const headerWishlistIcon = document.getElementById('headerWishlistIcon');
  const wishlistDrawer = document.getElementById('wishlistDrawer');
  if (!headerWishlistIcon || !wishlistDrawer) return;
  
  const iconRect = headerWishlistIcon.getBoundingClientRect();
  wishlistDrawer.style.position = 'fixed';
  wishlistDrawer.style.top = (iconRect.bottom) + 'px';
  wishlistDrawer.style.left = (iconRect.left + iconRect.width / 2) + 'px';
  wishlistDrawer.style.transform = 'translateX(-50%)';
}

/**
 * Initierar eventlyssnare på hjärtknappar:
 * Om vi är på en kollektionssida (elementet med id "product-grid" finns)
 * fäster vi en delegerad lyssnare på detta element.
 * Annars läggs lyssnare direkt på existerande knappar.
 */
function initHeartButtons() {
  // Direkt bindning för redan existerande hjärtknappar
  bindHeartButtons(document);
  markFavoriteHearts(loadFavorites());

  const observer = new MutationObserver(() => {
    bindHeartButtons(document);
    markFavoriteHearts(loadFavorites()); // <-- uppdatera hjärtstatus vid DOM-förändring
  });

  observer.observe(document.body, { childList: true, subtree: true });
}


// Hjälpfunktion som sätter event listeners på alla nya hjärtknappar
function bindHeartButtons(scope) {
  const heartButtons = scope.querySelectorAll('.wishlist-heart-button:not([data-initialized])');
  heartButtons.forEach((btn) => {
    btn.addEventListener('click', heartButtonHandler);
    btn.setAttribute('data-initialized', 'true'); // undvik dubbelbindning
  });
}


function heartButtonHandler(e) {
  e.preventDefault();
  e.stopPropagation();
  
  const btn = e.target.closest('.wishlist-heart-button');
  if (!btn) return;
  
  const productId = btn.getAttribute('data-product-id');
  let favorites = loadFavorites();
  let justAdded = false;
  
  if (favorites.includes(productId)) {
    favorites = favorites.filter(id => id !== productId);
  } else {
    favorites.push(productId);
    justAdded = true;
  }
  
  saveFavorites(favorites);
  markFavoriteHearts(favorites);
  
  if (justAdded) {
    const wishlistDrawer = document.getElementById('wishlistDrawer');
    if (wishlistDrawer) {
      wishlistDrawer.classList.add('open');
      wishlistDrawer.classList.remove('hidden');
    }
  }
  
  updateWishlistDrawer();
  updateWishlistCountBubble();
  positionWishlistDrawer();
}

/**
 * Wrapperfunktion som anropar window.fetchProductData (definierad i fetch-artist-metafields.js)
 */
async function fetchProductDataWrapper(productId) {
  if (typeof window.fetchProductData === 'function') {
    return await window.fetchProductData(productId);
  } else {
    console.warn("Global fetchProductData saknas, returnerar null för productId:", productId);
    return null;
  }
}

/**
 * Uppdaterar wishlist-drawern inkrementellt: tar bort gamla element och lägger till nya.
 */
async function updateWishlistDrawer() {
  const wishlistDrawerList = document.getElementById('wishlistDrawerList');
  if (!wishlistDrawerList) return;
  
  const favorites = loadFavorites();
  
  if (favorites.length === 0) {
    wishlistDrawerList.innerHTML = '<li style="text-align: center;">Inga favoriter än.</li>';
    return;
  }
  
  const favSet = new Set(favorites);
  
  // Ta bort listobjekt som inte längre finns i favoriter
  Array.from(wishlistDrawerList.children).forEach(li => {
    const liProductId = li.getAttribute('data-product-id');
    if (!liProductId || !favSet.has(liProductId)) {
      li.remove();
    }
  });
  
  // Lägg till nya produkter som saknas
  for (const productId of favorites) {
    if (!wishlistDrawerList.querySelector(`li[data-product-id="${productId}"]`)) {
      const data = await fetchProductDataWrapper(productId);
      if (data) {
        const li = document.createElement('li');
        li.setAttribute('data-product-id', productId);
        li.innerHTML = `
          <a href="/products/${data.handle}" class="wishlist-drawer-item" style="display: flex; align-items: center; text-decoration: none;">
            ${data.image ? `<img src="${data.image}" alt="${data.title}" style="width:50px; height:auto; margin-right:10px;">` : ''}
            <span class="wishlist-drawer-item-title">${data.title}</span>
          </a>
          <button class="wishlist-trash-btn" type="button" aria-label="Ta bort favorit">
            <span class="svg-wrapper">
              ${window.trashIcon}
            </span>
          </button>
        `;
        wishlistDrawerList.appendChild(li);
        setTimeout(() => {
          li.classList.add('visible');
        }, 10);
        
        const trashBtn = li.querySelector('.wishlist-trash-btn');
        if (trashBtn) {
          trashBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            e.preventDefault();
            removeProductFromWishlist(productId);
          });
        }
      }
    }
  }
}

function removeProductFromWishlist(productId) {
  let favorites = loadFavorites();
  favorites = favorites.filter(id => id !== productId);
  saveFavorites(favorites);
  markFavoriteHearts(favorites);
  updateWishlistDrawer();
  updateWishlistCountBubble();
}

function initHeaderWishlistIcon() {
  const headerWishlistIcon = document.getElementById('headerWishlistIcon');
  const wishlistDrawer = document.getElementById('wishlistDrawer');
  if (headerWishlistIcon && wishlistDrawer) {
    headerWishlistIcon.addEventListener('click', () => {
      wishlistDrawer.classList.toggle('hidden');
      if (!wishlistDrawer.classList.contains('hidden')) {
        positionWishlistDrawer();
      }
    });
  }
}

window.addEventListener('resize', () => {
  const wishlistDrawer = document.getElementById('wishlistDrawer');
  if (wishlistDrawer && !wishlistDrawer.classList.contains('hidden')) {
    positionWishlistDrawer();
  }
});

function updateWishlistCountBubble() {
  const favorites = loadFavorites();
  const bubble = document.querySelector('.wishlist-count-bubble');
  const bubbleNumber = document.getElementById('wishlist-count-number');
  if (!bubble || !bubbleNumber) return;
  
  if (favorites.length > 0) {
    bubble.classList.remove('hidden');
    bubbleNumber.textContent = favorites.length;
  } else {
    bubble.classList.add('hidden');
  }
}
